/* eslint-disable */
import PouchDBAdapterHttp from 'pouchdb-adapter-http'
import PouchDBCore from 'pouchdb-core'
import PouchDBMapReduce from 'pouchdb-mapreduce'
import configurations from '../configurations'

const PouchDBRemote = PouchDBCore.plugin(PouchDBAdapterHttp)
  .plugin(PouchDBMapReduce)
  .defaults({
    fetch (url, opts) {
      opts.credentials = 'include'
      return PouchDBCore.fetch(url, opts)
    },
    auth: configurations.auth,
    prefix: configurations.COUCHDB,
    skip_setup: true
  })

export default {
  complaint: new PouchDBRemote('complaint'),
  activity_trading: new PouchDBRemote('activity_trading'),
  contact: new PouchDBRemote('contact'),
  council_operation: new PouchDBRemote('council_operation'),
  ebilling: new PouchDBRemote('ebilling'),
  trading: new PouchDBRemote('trading'),
  digital_license: new PouchDBRemote('digital_license')
}
